module.exports = __webpack_public_path__ + "img/Gruppenführer_O.6d5cfad0.svg";